/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {generateEmploymentPasscode} from '../api'

export const useMutationGenerateEmploymentPasscode = createReactQueryMutationHook('generateEmploymentPasscode', generateEmploymentPasscode)
